import React, { useState } from "react"
import ytSearch from "youtube-search"
import { useDebouncedCallback } from "use-debounce"
import { Button } from "../common"

function OnboardVideos({ query }) {
    const [loadSearch, setLoadSearch] = useState(false)
    const [videos, setVideos] = useState(null)

    const loadResults = (query, pageToken) => {
        ytSearch(
            query,
            {
                maxResults: 5,
                key: process.env.GATSBY_GMAPS_API_KEY,
                pageToken,
            },
            function (err, results, pageInfo) {
                if (err) return console.log("Error finding videos", err)

                if (!pageToken) setVideos({ results, pageInfo })
                // Append videos to results when next page is set
                else
                    setVideos((prevVideos) => ({
                        results: [...prevVideos.results, ...results],
                        pageInfo,
                    }))
            }
        )
    }

    const loadDebounced = useDebouncedCallback(loadResults, 300)

    if (!loadSearch)
        return (
            <Button
                onClick={() => {
                    setLoadSearch(true)
                    loadResults(query)
                }}
            >
                Load Onboard Videos
            </Button>
        )

    return (
        <>
            <input
                className="mt-6 w-full px-4 py-2 shadow rounded-lg focus:outline-none focus:ring focus:border-indigo-200"
                defaultValue={query}
                onChange={(e) => loadDebounced(e.target.value)}
                autoFocus
            />
            {videos?.results?.map((video) => (
                <div
                    key={video.id}
                    className="my-10 w-full aspect-w-16 aspect-h-9"
                >
                    <iframe
                        src={`https://www.youtube.com/embed/${video.id}`}
                        title={video.title}
                        referrerPolicy="origin"
                        allowFullScreen
                    ></iframe>
                </div>
            ))}
            {videos?.pageInfo?.nextPageToken && (
                <Button
                    onClick={() => {
                        loadResults(query, videos.pageInfo.nextPageToken)
                    }}
                >
                    Load more
                </Button>
            )}
        </>
    )
}

export default OnboardVideos
